import { ReactComponent as BookIcon } from 'src/assets/icons/ic-book.svg';
export const RelevantDocs = ({
    relevantDocs,
    title,
    kind = 0,
    styleDoc = {}
}) => {
    const styles = {
        container: {
            color: 'rgb(18, 52, 71)',
            fontSize: '14px',
        },
        list: {
            listStyleType: 'None',
            padding: '0',
        },
        listItem: {
            backgroundColor: 'rgb(243, 245, 247)',
            marginBottom: '8px',
            padding: '10px 12px 12px',
            borderRadius: '6px',
            cursor: 'pointer',
            transition: 'color 0.15s ease-in-out 0s, background-color 0.15s ease-in-out 0s, border-color 0.15s ease-in-out 0s',
            position: 'relative',
            lineHeight: '1.4',
            display: 'flex'
        },
        bookIcon: {
            position: 'relative',
            top: '2px',
            marginRight: '8px',
            width: '20px',
        },
        lineClampStyle: {
            display: '-webkit-box',
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
            WebkitLineClamp: 2,
        },
        p: {
            fontSize: '0.7rem',
            fontWeight: '600',
            color: 'rgb(0 2 4 / 60%)',
            marginBottom: '-7px',
        },
        relevantBoxWelcomeMsg: {
            marginTop: "-5px",
        },
        k0: {
            marginTop: "-5px",
        },
        k1: {
            // marginTop: "10px",
            // marginLeft: "40px",
        },
        relevantDoc: {
            backgroundColor: "rgb(221 225 230)",
        }
    }

    const openDoc = (url) => {
        window.open(url);
    };

    return (
        <div style={styles['k' + kind]}>
            { title && <p style={styles.p}>{title}</p> }
            <div style={styles.container}>
                <ul style={styles.list}>
                    {relevantDocs.map((item, index) => (
                        <li style={{ ...styles.listItem, ...styleDoc }} key={index} onClick={() => openDoc(item.url)}>
                            <div>
                                <BookIcon style={styles.bookIcon} />
                            </div>
                            <div style={styles.lineClampStyle}>{item.title}</div>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    )
};